import { SHA_256 } from "./static";

export const getStateCodeFromUrl = () => {
  const href = window.location.href;
  const index = href.indexOf("bcbs");
  const char1 = href.charAt(index + 4);
  const char2 = href.charAt(index + 5);
  //const states = ['il', 'mt', 'nm', 'ok', 'tx'];
  let code = "il";

  if (index > -1 && char1 && char2) {
    code = (char1 + char2).toLowerCase();
  }
  return code;
};

const dec2hex = (dec: number) => {
  return ("0" + dec.toString(16)).substr(-2);
};

export const generateRandomString = () => {
  const array = new Uint32Array(56 / 2);
  window.crypto.getRandomValues(array);
  return Array.from(array, dec2hex).join("");
};

const sha256 = (plain: string) => {
  // returns promise ArrayBuffer
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  return window.crypto.subtle.digest(SHA_256, data);
};

const base64urlencode = (a: ArrayBufferLike) => {
  let str = "";
  const bytes = new Uint8Array(a);
  const len = bytes.byteLength;
  for (let i = 0; i < len; i++) {
    str += String.fromCharCode(bytes[i]);
  }
  return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

export const challengeFromVerifier = async (v: string) => {
  const hashed = await sha256(v);
  return base64urlencode(hashed);
};
